import { searchCommonConfig } from './common'

/**
 * NovelSprig 品牌搜索页面配置
 */
export const searchConfig = {
  ...searchCommonConfig,
  colors: {
    inputBg: '#0000000A',
    startReadingBg: 'linear-gradient(90deg, #10B981 0.03%, #059669 100%)',
  },
}
